import actions from './users/actions';
import getters from './users/getters';
import mutations from './users/mutations';

const defaultState = {
  firstName: '',
  lastName: '',
  userId: '',
  email: '',
  accountType: '',
  emailInvoice: true,
  smsEnabled: true
}

export const users = {
  namespaced: true,
  state: {
    newUser: {
      ...defaultState
    },
    users: {},
    userRoles: {},
    newUserACLs: []
  },
  actions,
  getters,
  mutations,
}